import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import {
  ContractorDeliveryPriceCreate,
  ContractorDeliveryPriceDetail,
  ContractorDeliveryPriceItemList,
  ContractorDeliveryPriceUpdate,
} from '../ContractorDeliveryPrice.entity';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorDeliveryPriceList: builder.query<Array<ContractorDeliveryPriceItemList>, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorDeliveryPrice/${data.id}`,
      }),
    }),
    getContractorDeliveryPriceDetail: builder.query<ContractorDeliveryPriceDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorDeliveryPrice/${data.id}/details`,
      }),
    }),
    changeContractorDeliveryPrice: builder.mutation<void, ContractorDeliveryPriceUpdate>({
      query: (data) => ({
        url: `/v1/ContractorDeliveryPrice/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorDeliveryPrice: builder.mutation<void, ContractorDeliveryPriceCreate>({
      query: (data) => ({
        url: '/v1/ContractorDeliveryPrice',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorDeliveryPrice: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorDeliveryPrice/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeContractorDeliveryPriceMutation,
  useCreateContractorDeliveryPriceMutation,
  useDeleteContractorDeliveryPriceMutation,
  useGetContractorDeliveryPriceDetailQuery,
  useGetContractorDeliveryPriceListQuery,
  useLazyGetContractorDeliveryPriceDetailQuery,
  useLazyGetContractorDeliveryPriceListQuery,
} = request;
